import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import API from "../../lib/api";
import { fmtDate } from "../../lib/dateUtil";
import { CalendarCheck, WarningCircle } from "@phosphor-icons/react";

/** Hub banner: issued RAMS whose review date is due within 14 days or has passed. */
export default function RamsReviewBanner() {
  const [rows, setRows] = useState(null);
  useEffect(() => { API.get("/hs/rams/review-due").then(({ data }) => setRows(data.rams || [])).catch(() => setRows([])); }, []);
  if (!rows || rows.length === 0) return null;
  const overdue = rows.filter(r => r.overdue);
  const due = rows.filter(r => !r.overdue);
  return (
    <div className={`rounded-lg border-2 p-4 ${overdue.length ? "border-red-300 bg-red-50/70 dark:bg-red-950/20" : "border-amber-300 bg-amber-50/70 dark:bg-amber-950/20"}`} data-testid="rams-review-banner">
      <div className="flex items-start gap-3">
        {overdue.length ? <WarningCircle className="h-5 w-5 text-red-600 shrink-0 mt-0.5" weight="fill" /> : <CalendarCheck className="h-5 w-5 text-amber-600 shrink-0 mt-0.5" weight="fill" />}
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold">
            {overdue.length ? `${overdue.length} RAMS overdue for review` : ""}{overdue.length && due.length ? " · " : ""}{due.length ? `${due.length} due within 14 days` : ""}
          </p>
          <p className="text-xs text-muted-foreground mt-0.5">Re-check each one before the next visit — open it, update the review date and re-issue if anything changed.</p>
          <ul className="mt-2 flex flex-wrap gap-1.5">
            {rows.slice(0, 8).map(r => (
              <li key={r.id}>
                <Link to={`/health-safety/rams/${r.id}`} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs hover:bg-background ${r.overdue ? "border-red-300 text-red-700 dark:text-red-300" : "border-amber-300 text-amber-800 dark:text-amber-300"}`} data-testid={`rams-review-${r.id}`}>
                  <span className="font-mono">{r.reference}</span><span className="truncate max-w-[14rem]">{r.title}</span>
                  <span className="opacity-70">{r.overdue ? `${-r.days_until_review}d overdue` : r.days_until_review === 0 ? "today" : `${r.days_until_review}d`} · {fmtDate(r.review_date)}</span>
                </Link>
              </li>
            ))}
            {rows.length > 8 && <li className="text-xs text-muted-foreground self-center">+{rows.length - 8} more</li>}
          </ul>
        </div>
      </div>
    </div>
  );
}
